import { ref, unref } from 'vue';

/* NPM Plugins */
import { ElForm } from 'element-plus';

/* Components */
import { ErpAsyncForm } from '../forms/Index'

/* Dtos */
export const useErpAsyncForm = () => {

    const formRef = ref<typeof ErpAsyncForm>()

    const elFormRef = ref<ComponentRef<typeof ElForm>>()

    const register = (ref: typeof ErpAsyncForm, elRef: ComponentRef<typeof ElForm>) => {

        formRef.value = ref
        elFormRef.value = elRef

    }

    const methods = {

        getLoadStatus: () => {

            return unref(formRef)?.funcs.getLoadStatus()

        },

        setLoading: (isLoad: boolean) => {

            unref(formRef)?.funcs.setLoadStatus(isLoad);

        },

        setFormData: (data: any) => {

            unref(formRef)?.funcs.setFormData(data)

        },

        getFormData: () => {

            return unref(formRef)?.funcs.getData()

        }

    }

    return { elFormRef, register, methods }

}